<template>
    <div class="def-slider-wrapper">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DefSliderWrapper',
}
</script>

<style lang="scss" scoped>
.def-slider-wrapper{
    :deep(.swiper-button-next:after),
    :deep(.swiper-button-prev:after){
        font-size: 16px;
        color: var(--text-colour-primary);
    }
    :deep(.swiper-pagination-bullet){
        background-color: #DFDFDF;
        width: 10px;
        height: 10px;
        margin-left: 0;
        &:not(:last-child){
            margin-right: 22px;
        }
    }
    :deep(.swiper-pagination-bullet-active){
        background-color: var(--border-colour-primary);
    }
    :deep(.swiper-pagination) {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        position: static;
        margin-top: 24px;
    }
}
</style>